import React from 'react'
import clsx from 'clsx'
import LockIcon from '@mui/icons-material/Lock'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import Switch, { SwitchProps } from '../../formControls/Switch'
import TextField, {
	TextFieldProps,
} from '../../formControls/TextField'
import Checkbox from '../../formControls/Checkbox'
import { LayoutRow } from '../../layout'

export type BaseInheritedFieldProps = {
	name: string
	label: string
	inherited: boolean
	isTopLevelSite?: boolean
	onChange?: () => void
	hideInheritedLabel?: boolean
	helperText?: string
}

export type InheritedTextFieldProps = {
	type: 'string'
} & BaseInheritedFieldProps &
	Omit<TextFieldProps, 'onChange'>

export type InheritedSwitchFieldProps = {
	type: 'boolean'
} & BaseInheritedFieldProps &
	Omit<SwitchProps, 'onChange'>

export type InheritedFieldProps =
	| InheritedSwitchFieldProps
	| InheritedTextFieldProps

const InheritedField = ({
	name,
	label,
	type,
	inherited,
	isTopLevelSite = false,
	onChange,
	hideInheritedLabel = false,
	helperText,
}: InheritedFieldProps) => {
	const handleInheritanceChange = () => {
		onChange?.()
	}

	const handleTextChange = () => {
		onChange?.()
	}

	const handleSwitchChange = () => {
		onChange?.()
	}

	const inheritedLabel = inherited
		? 'Break Inheritance'
		: 'Use Inherited Value'

	return (
		<LayoutRow
			className={clsx(
				'flex flex-row flex-wrap items-center',
				hideInheritedLabel && 'justify-between max-w-96'
			)}
		>
			{type === 'string' && (
				<TextField
					name={`${name}.value`}
					label={label}
					onChange={handleTextChange}
					disabled={inherited}
					helperText={helperText}
				/>
			)}

			{type === 'boolean' && (
				<Switch
					name={`${name}.value`}
					label={label}
					onChange={handleSwitchChange}
					disabled={inherited}
				/>
			)}

			{!isTopLevelSite && (
				<Checkbox
					label={hideInheritedLabel ? '' : inheritedLabel}
					name={`${name}.inherited`}
					onClick={handleInheritanceChange}
					checked={inherited}
					checkedIcon={<LockIcon aria-label={inheritedLabel} />}
					icon={<LockOpenIcon aria-label={inheritedLabel} />}
				/>
			)}
		</LayoutRow>
	)
}

export default InheritedField
